import Number from "@number-flow/react";
import { Minus, Plus } from "lucide-react";
import { motion } from "motion/react";
import { useState } from "react";

// TODO: accessibility

const min = 1;
const max = 4;

export function NumberInput() {
  const [value, setValue] = useState(max);

  const onMinus = () => setValue((v) => Math.max(min, v - 1));
  const onPlus = () => setValue((v) => Math.min(max, v + 1));

  return (
    <motion.div
      whileTap={{
        scale: 0.95,
      }}
      className="relative h-8 px-px bg-border rounded-lg flex items-center justify-center tabular-nums border border-border overflow-hidden"
    >
      <motion.div
        className="z-10 absolute inset-px bg-background rounded-md"
        animate={{
          animationDelay: "0.2s",
          transition: {
            velocity: 0.5,
            type: "spring",
          },
          width:
            value === max
              ? "calc(100% - 2px)"
              : `calc(${(value / max) * 100}% - 1px)`,
        }}
      />
      <div className="z-20 flex gap-1 justify-between items-center [&_svg]:text-muted-foreground [&_svg]:size-4 [&>button]:h-full">
        <button onClick={onMinus} className="px-1">
          <Minus />
        </button>
        <span className="text-xs font-mono font-medium">
          <Number
            value={value}
            // suffix={`/${max}`}
            className="part-suffix:text-muted-foreground/90 part-suffix:text-[11px]"
          />
        </span>
        <button onClick={onPlus} className="px-1">
          <Plus />
        </button>
      </div>
    </motion.div>
  );
}
